import React, {  useEffect , useState } from 'react';
import PromoBanner from '../Components/PromoBanner';
import Navbar from '../Components/Navbar';
import Slider from '../Components/Slider';
import Products from '../Components/Products';
import AllCategories from '../Components/AllCategories';
import CollectionSection from '../Components/CollectionSection';
import PrintShop from '../Components/PrintShop';
import Rate from '../Components/Rate';
import Sample from '../Components/Sample';
import Subscribe from '../Components/SubscribeSection';
import FixedImageMessage from '../Components/FixedImageMessage';
import Footer from '../Components/Footer';




const Home = () => {

    const [popupMessage, setPopupMessage] = useState('');

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    
  useEffect(() => {
    // Check query parameters for payment status
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('status');

    if (status === 'success') {
      setPopupMessage(
        `Payment successful! Thank you for your order.\n\nYou can check the status of your order from your account section.`
      );
      }
    }, []); 


      
    return (

<div>
   <PromoBanner />
   <Navbar />
   <Slider />
   <Products />
   <AllCategories />
   <CollectionSection />
   <PrintShop />
   {/* <Rate /> */}
   {popupMessage && (
  <div
    className="
      fixed inset-0
      flex items-center justify-center
      bg-gray-900 bg-opacity-50
      z-50
    "
  >
    <div
      className="
        relative       
        bg-white p-6 rounded-lg shadow-lg text-center
        w-80           
      "
    >
      <p className="text-sm font-semibold mb-4">
        {popupMessage}
      </p>
      <button
        onClick={() => setPopupMessage("")}
        className="
          mt-2
          bg-pink-500 hover:bg-pink-600
          text-white py-2 px-4 rounded-lg
        "
      >
        Close
      </button>
    </div>
  </div>
)}

   <Sample />
   <Subscribe />
   <FixedImageMessage />
   <Footer />
</div>
    )}

export default Home;
